module.exports = __webpack_public_path__ + "img/lianwang-1.f4e509b0.jpg";